// console.log(Alpine.toBind);

// window.Alpine.toBind.forEach(([name, library]) => {
//   console.log([name, library]);
//   Alpine.bind(name, library);
// });
// document.addEventListener('alpine:init', () => {
//   console.log('sss');
// });

window.Alpine.start();
